// https://next-auth.js.org/configuration/pages#oauth-sign-in
import Head from "next/head";

import HeaderLanding from "@components/Landing/Header";
import DefaultTags from "@components/DefaultTags";
import Link from "next/link";

// heavy design inspiration from https://tailwindcss.com/blog/2023-04-24-new-changelog-template-and-the-biggest-tailwind-ui-update-ever

function ChangelogPage() {
  const head = {
    title: "FixTheOps | About",
    description: "About page",
    image: "https://fixtheops.dev/fixtheops-logo/fixtheops-logo-bg-white.png",
    type: "website",
    url: "https://fixtheops.dev",
  };

  return (
    <>
      <Head>
        <DefaultTags />
        <title>{head.title}</title>
        <meta name="description" content={head.description}></meta>
        <link rel="canonical" href="https://fixtheops.dev" key="canonical" />
        <meta name="robots" content="all" key="robots" />

        {/* Open Graph */}
        <meta property="og:title" content={head.title} />
        <meta property="og:type" content={head.type} />
        <meta property="og:description" content={head.description} />
        <meta property="og:url" content={head.url} />
        <meta property="og:image" content={head.image} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@fixtheops" />
        <meta name="twitter:title" content={head.title} />
        <meta name="twitter:description" content={head.description} />
        <meta name="twitter:image" content={head.image} />

        {/* <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" /> */}
        {/* <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" /> */}
        {/* <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" /> */}
        <link rel="manifest" href="/site.webmanifest" />

        <link
          rel="apple-touch-icon"
          sizes="57x57"
          href="/favicons/apple-icon-57x57.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="60x60"
          href="/favicons/apple-icon-60x60.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="72x72"
          href="/favicons/apple-icon-72x72.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href="/favicons/apple-icon-76x76.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="114x114"
          href="/favicons/apple-icon-114x114.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href="/favicons/apple-icon-120x120.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href="/favicons/apple-icon-144x144.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href="/favicons/apple-icon-152x152.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/favicons/apple-icon-180x180.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href="/favicons/android-icon-192x192.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicons/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href="/favicons/favicon-96x96.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicons/favicon-16x16.png"
        />
        <link rel="manifest" href="/favicons/manifest.json" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
        <meta name="theme-color" content="#ffffff"></meta>
      </Head>

      <div className="landing">
        <HeaderLanding />

        <div className="px-4 sm:px-6 md:px-8 mt-8">
          <div className="max-w-2xl mx-auto">
            <main>
              {/* <div className="relative mx-auto max-w-[37.5rem] pt-20 text-center pb-20">
              <h1 className="mb-4 px-10 font-bold leading-none tracking-tighter text-gray-900 text-4xl md:text-5xl max-w-screen-lg mx-auto">
                Changelog
              </h1>
            </div> */}
              {/* <div>WIP page 😅</div> */}
              <article>
                {/* <div className="text-slate-700 mb-2">
                  <time dateTime="2023-10-24T08:00:00.000Z">
                    Wednesday, October 24, 2023
                  </time>
                </div> */}
                <h2 className="text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">
                  Welcome! 👋
                </h2>
                <div className="mt-6 prose prose-slate">
                  Hey, I am François. A French 🇫🇷 &quot;DevOps&quot; engineer
                  working in Germany 🇩🇪.
                  <br />
                  <br />
                  FixTheOps is a personal project that started in January 2023,
                  when I started to sketch the first landing page with a simple
                  waiting list during the evening, or during holidays. After
                  gaining some first users, I got really encouraging feedback,
                  so I improved the website more and more until the moment I
                  could just remove the waiting list.
                  <br />
                  <br />
                  However, this project is costly, I paid for some parts of it
                  myself, and used cloud credits whenever I could find some (the
                  whole project is deployed with FluxCD, which makes it easy to
                  deploy to a completely new environment). So all contributions
                  are welcome:{" "}
                  <Link href="https://www.buymeacoffee.com/fixtheops">
                    buy me coffee
                  </Link>
                  ,{" "}
                  <a
                    href="mailto:hello@fixtheops.dev"
                    target="_blank"
                    rel="noreferrer"
                  >
                    sponsorships
                  </a>
                  , etc.
                  <br />
                  <br />
                  The funny part is that I probably spent more time on React &
                  CSS than on the backend :D
                  <br />
                  <br />
                  Nevertheless, I hope you enjoy playing with the challenges,
                  and get this amazing feeling when you crack them one by one.
                  <br />
                  <div className="flex justify-end mt-4">
                    <Link href="https://github.com/Lp-Francois" className="">
                      François LP
                    </Link>
                  </div>
                  <h3>Related Resources:</h3>
                  <ul>
                    <li>
                      <Link href="https://github.com/FixTheOps">
                        FixTheOps&apos;s GitHub
                      </Link>
                    </li>
                    <li>
                      <Link href="https://discord.com/invite/bBwVRrNAW8">
                        Discord community
                      </Link>
                    </li>
                  </ul>
                </div>
                <hr className="mt-8" />
              </article>
            </main>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangelogPage;
